import _ from 'lodash';
import DepsService from 'services/dependencies';
import template from './documents-filter.html';
import removeCategoryConfirmTemplate from './views/category-delete-confirm.html';

const DOCUMENTS_CONTEXT = 'documents';

const mapStateToThis = ({ session, config, documents }) => {
  const { locale } = session;
  const { locales } = config;
  const { categories, tags } = documents;

  return {
    locale,
    locales,
    categories,
    tags,
  };
};

const mapDispatchToThis = {};

@Inject('$ngRedux', 'gettextCatalog', 'Notifications', 'Responsive', '$mdSelect')
class DocumentsFilterController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.jurisdictionId = this.config.jurisdictionId;
    // this.folders = this.getFolders();

    DepsService.restSrv.list(DOCUMENTS_CONTEXT, DepsService.rest.documents.types.url, { locale: this.locale }).then((result) => {
      this.folders = result;
    });
  }

  $onDestroy() {
    this.unsubscribe();
  }

  getFolders() {
    return [
      {
        name: this.gettextCatalog.getString('Document'),
        fileType: 'document',
      },
      {
        name: this.gettextCatalog.getString('Audio'),
        fileType: 'audio',
      },
      {
        name: this.gettextCatalog.getString('Image'),
        fileType: 'image',
      },
      {
        name: this.gettextCatalog.getString('Video'),
        fileType: 'video',
      },
    ];
  }

  onOpenCategoryDialog(category, $event) {
    $event.stopPropagation();

    // TODO bad fix for material
    this.$mdSelect.hide();

    return this.openEditCategoryDialog({ category });
  }

  removeCategory(category, $event) {
    $event.stopPropagation();

    // TODO bad fix for material
    this.$mdSelect.hide();

    this.Notifications.showComplexDialog({
      template: removeCategoryConfirmTemplate,
    }).result.then((result) => {
      if (result) {
        this.onRemoveCategory({ category }).then(() => {
          this.clearFiltersAndReload();
        });
      }
    });
  }

  sortCategories() {
    return (category) => _.get(category, `translations[${this.locale}].name`);
  }
}

export default class DocumentsFilterComponent {
  constructor() {
    this.template = template;
    this.controller = DocumentsFilterController;
    this.bindings = {
      filters: '<',
      config: '<?',
      canEdit: '<',
      model: '<',
      onRemoveCategory: '&',
      openEditCategoryDialog: '&',
      clearFiltersAndReload: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/documents/components/documents-filter/documents-filter-component.js